<script>
  import Dropdown from '../../Common/Dropdown.svelte';
  import Checkbox from '../../Common/Checkbox.svelte';
  import { External, M } from '../../external';
  import { onDestroy, onMount } from 'svelte';
  import { getRandomInt } from '../../Common/tools';

  export let question,
    updateQuestion = () => {},
    deleteQuestion = () => {},
    closePopup = () => {};

  let sortable, jqSortable;

  const questionTypes = [
    { uniqueId: 'text', name: M.SHORT_TEXT },
    { uniqueId: 'multiline', name: M.LONG_TEXT },
    { uniqueId: 'select', name: M.DROPDOWN },
    { uniqueId: 'radio', name: M.SINGLE_CHOICE },
    { uniqueId: 'checkbox', name: M.MULTI_CHOICE }
  ];

  const questionTypesByUniqueId = questionTypes.reduce((acc, questionType) => {
    acc[questionType.uniqueId] = questionType;
    return acc;
  }, {});

  const onQuestionTypeChanged = (value) => {
    debugger;
    if (!['select', 'radio', 'checkbox'].includes(value)) {
      question = { ...question, options: [] };
      updateQuestion(question.id, 'options', []);
    }
    question.type = value;
    updateQuestion(question.id, 'type', value);
  };

  onMount(() => {
    jqSortable = External.$(sortable);
    jqSortable.sortable({
      items: '.option-item',
      handle: '.move-icon',
      containment: 'parent',
      tolerance: 'pointer',
      axis: 'y',
      start: (event, ui) => {
        ui.item.data('idx', ui.item.index());
      },
      stop: (event, ui) => {
        let newIdx = ui.item.index();
        let oldIdx = ui.item.data('idx') || 0;
        if (newIdx !== oldIdx) {
          let elem = question.options[oldIdx];
          question.options.splice(oldIdx, 1);
          question.options.splice(newIdx, 0, elem);
          question.options = question.options;
          refreshKey = getRandomInt();
          updateQuestion(question.id, 'options', question.options);
        }
      }
    });
  });

  let refreshKey = getRandomInt();

  onDestroy(() => {
    jqSortable.sortable('destroy');
    jqSortable = null;
  });
</script>

<div class="popup-widget-wrapper">
  <div class="questions col20 f-left">
    <div class="question-item col20 f-left">
      <div class="question-header flex-col col20 f-left">
        <div class="popup-input-wrapper mb-10">
          <h5>{M.QUESTION_TITLE}</h5>
          <input
            type="text"
            bind:value={question.label}
            on:input={() => {
              updateQuestion(question.id, 'label', question.label);
            }}
            placeholder={M.QUESTION_TITLE_PLACEHOLDER} />
        </div>
        <div class="question-controls flex-col col20 f-left">
          <div class="col20-left">
            <Dropdown
              activeItem={questionTypesByUniqueId[question.type] || questionTypes[0]}
              items={questionTypes}
              on:change={(e) => onQuestionTypeChanged(e.detail.selected.uniqueId)} />
          </div>
          <div class="col20 f-left">
            <Checkbox
              bind:data={question.required}
              on:change={() => {
                updateQuestion(question.id, 'required', question.required);
              }}
              label={M.REQUIRED_FIELD} />
          </div>
        </div>
      </div>

      <div
        class:none={!['select', 'radio', 'checkbox'].includes(question.type)}
        class="col20 f-left form-admin-style-2">
        <div class="options col20 f-left">
          <div class="options-header col20 f-left mb-10">
            <h4 class="col20 f-left mt-10 mb-10">{M.OPTIONS}</h4>
            <div class="col20 f-left t-left">
              <a
                on:click={() => {
                  const newOptions = [...question.options, M.ADD_OPTION];
                  question.options = newOptions;
                  refreshKey = getRandomInt();
                  updateQuestion(question.id, 'options', newOptions);
                }}
                class="middle-button blue with-icon inline-block f-none">{M.ADD_OPTION}</a>
            </div>
          </div>
          <div bind:this={sortable} class="ui-sortable form-wrapper">
            {#each question.options as option, index (index + refreshKey)}
              <div class="option-item field field-type-text">
                <span
                  class="move-icon button-tooltip ui-sortable-handle"
                  data-tooltip="simpleMove"
                  data-original-title=""
                  title=""></span>
                <input
                  type="text"
                  bind:value={option}
                  on:input={() => {
                    const newOptions = [...question.options];
                    updateQuestion(question.id, 'options', newOptions);
                  }}
                  placeholder={M.ENTER_OPTION_TEXT}
                  class="label-field modify" />
                <div class="buttons-wrapper flex-none">
                  <a
                    data-tooltip="simpleDelete"
                    class="delete delete-icon light-gray-icon modify button-tooltip mr-10 circle-effect"
                    on:click={() => {
                      const newOptions = question.options.filter((_, i) => i !== index);
                      question.options = newOptions;
                      refreshKey = getRandomInt();
                      updateQuestion(question.id, 'options', newOptions);
                    }}><i class="material-icons-outlined">delete</i></a>
                </div>
              </div>
            {/each}
          </div>
        </div>
      </div>
      <div class="col20-left mt-25">
        <a
          class="middle-button gray"
          on:click={() => {
            deleteQuestion(question.id);
            closePopup();
          }}>{M.DELETE}</a>
      </div>
    </div>
  </div>
</div>
